export const catTipoImagen = {
    NOAPLICA: 0,
    PORTADA: 1,
    HISTORIA: 2,
    PUBLICACION: 3,
    MINIATURA: 4,
    GALERIA: 5,
}